module.exports = __webpack_public_path__ + "media/img/frontend_application/three-sixty-icon-sm-294c60f2b9ba9e5037cdaa75d4a40253.png";